<template>
  <div style="padding: 30px">
    <div style="display: flex">
      <el-select v-model="project_id" placeholder="请选择" class="marginL2" @change="handleChangeProject">
        <el-option
          v-for="item in projectList"
          :key="item.project_id"
          :label="item.project_name_cn"
          :value="item.project_id"
        >
        </el-option>
      </el-select>
      <el-select v-model="week_plan_id" placeholder="请选择" class="marginL2"  @change="handleChangeWeek" style="width:300px">
        <el-option
          v-for="item in weekplanList"
          :key="item.mgmt_plan_id"
          :label="
            item.plan_name + kong + '(' + item.begin_date + '-' + item.end_date + ')'
          "
          :value="item.mgmt_plan_id"
        >
        </el-option>
      </el-select>
      <div class="jindukuang marginL2">审核意见:{{progress}}</div>
    </div>
    <div v-if="showWeekList && tableData.length > 0">
      <el-table
        row-key="mgmt_task_id"
        ref="table"
        class="table"
        :data="tableData"
        :span="24"      
        :row-style="{ height: '36px', padding: '8px 0' }"
        :header-row-style="{ height: '88px' }"
        :header-cell-style="{
          textAlign: 'center',
          padding: '4px 0',
          backgroundColor: '#fff',
          color: '#4c4c4c',
        }"
        :cell-style="addClass"
        :span-method="objectSpanMethod"
        :cell-class-name="cellClassName" 
        border
        height=700
        style="width: 100%; margin-top: 20px"
      >

        <el-table-column prop="depart_id" label="部门"  width="80">
          <template slot-scope="scope">
            <span class="taskName">{{ scope.row.depart_name }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="阶段任务" width="220">
        <template slot-scope="scope" >
           <div>{{ scope.row.task_name_str }}</div>
        </template>
      </el-table-column>
<!-- :width="isInputBlur?'130px':'80px'" -->
      <el-table-column prop="content" label="内容"  show-overflow-tooltip min-width="260">
              <template slot-scope="scope">
               <div style="white-space: normal;">{{ scope.row.content }} <span style="color:red;font-size:12px;">{{scope.row.comment}}</span></div> 

              </template>
      </el-table-column>

        <!-- <el-table-column prop="content" label="内容"  min-width="280px"> </el-table-column> -->
        <el-table-column
          v-for="(item, index) in weekDay"
          :prop="item.dayname"
          label="日期"
          :key="index"
          align="center"
          :index="index"
          width="26"
        >
      <template slot="header">
        <div class="daKuang">
        <div class="waiKuang">{{item.tian}}</div>
        <hr></hr>
        <div class="riqi">{{item.ri}}</div>
        <div class="yuefen">{{item.qi}}月</div>
      </div>             
      </template>
    </el-table-column>

       <el-table-column prop="project_company_id" label="完成人" width="180">
        <template slot-scope="scope">
          <div style="display: flex">
            <el-tag
              :key="index"
              v-for="(tag, index) in scope.row.roles_1"
              :disable-transitions="false"
              style="margin-left:10px"
            >
              {{tag.employee_name_abbr}}
            </el-tag>
          </div>
        </template>
      </el-table-column>
        <el-table-column prop="task_status_explaination" label="审批人" width="90" >
          <template slot-scope="scope">
          <div style="display: flex">
            <el-tag
              :key="index"
              v-for="(tag, index) in scope.row.roles_2"
              :disable-transitions="false"
              style="margin-left:10px"
            >
              {{tag.employee_name_abbr}}
            </el-tag>
          </div>
        </template>
        </el-table-column>
        <el-table-column prop="task_status_explaination" label="状态" width="80"> 
            <template slot-scope="scope">
               <div :class="[scope.row.task_status_explaination == '已完成' ? 'xuanG': '', 
        scope.row.task_status_explaination == '未完成' ? 'xuanR': '',
        scope.row.task_status_explaination == '取消' ? 'xuanY': '']">{{ scope.row.task_status_explaination }}</div> 

              </template>
        </el-table-column>
      </el-table>
    </div>
    <div v-if="showWeekList == false" class="deftip">暂无数据</div>
  </div>
</template>

<script>
import axios from "axios";
import { getBaseInfo } from "@/api/user";
import {
  getTaskOptionValue,
  gettasklistStrName,
  gettaskOptions,
  getpsheList,
  getuserInfo,
} from "@/lib/until";
import { formatDay, getDays } from "@/lib/weektime";
export default {
  data() {
    return {
      projectList: [],
      project_id: "",
      weekplanList: [],
      week_plan_id: "",
      showWeekList: false,
      tableData: [],
      spanArr: [],
      position: 0,
      // 周表头
      weekDay: [],
      base_info: "",
      createdWeekPlan: false,
      employeeDeparts: [],
      kong: "",
      progress:"",
    };
  },
  mounted() {
    this.getInfo = getuserInfo();
    this.getEmployee_depart();
    this.getBaseInfo();
    this.getPorjectList();
  },
  methods: {
    //计算百分比
    getprogress(newData) {
      let fenzi = 0;
      let fenmu = 0;
      for (let key in newData) {
        if (
          newData[key].task_status_explaination == "已完成" ||
          newData[key].task_status_explaination == "未完成"
        ) {
          fenmu += 1;
        }
        if (newData[key].task_status_explaination == "已完成") {
          fenzi += 1;
        }
      }
      let jindu = parseInt((fenzi / fenmu) * 100);
    //   return jindu;
      this.progress = jindu + "%";
    },
    //获取部门列表
    getBaseInfo() {
      getBaseInfo().then((res) => {
        this.base_info = res;
        //console.log(res.project_list);
        this.project_list = res.project_list;
        let depart_list = res.depart_list;
        let derList = [];
        for (let key in depart_list) {
          if (depart_list[key].has_project_phases == 1) {
            derList.push(depart_list[key]);
          }
        }
        this.depart_list = derList;
      });
    },
    //获取项目列表数据
    getPorjectList() {
      getBaseInfo().then((res) => {
        this.base_info = res;
        //console.log(res.project_list);
        let project_list = res.project_list;
        this.projectList = Object.values(project_list);
        console.log(this.projectList);
        if (this.projectList.length > 0) {
          this.project_id = this.projectList[0].project_id;
          this.getWeekPlan();
        }
      });
    },
    //获取周计划的列表；
    getWeekPlan() {
      axios
        .post(IPConfig.IP + "/kpi-management/mgmt/plan/sel_mgmt_plan.php", {
          project_id: this.project_id,
        })
        .then((res) => {
          console.log(res.data.plan_results);
          this.weekplanList = res.data.plan_results;
          if (this.weekplanList.length > 0) {
            this.week_plan_id = this.weekplanList[0].mgmt_plan_id;
            this.showWeekList = true;
            this.getPlanDetail();
          } else {
            this.showWeekList = false;
          }
        });
    },
    //查找周计划列表

    getPlanDetail() {
      // mgmt_plan_id: this.week_plan_id,
      //mgmt_plan_id: 6,
      axios
        .post(IPConfig.IP + "/kpi-management/mgmt/plan/plan_detail.php", {
          mgmt_plan_id: this.week_plan_id,
        })
        .then((res) => {
          console.log(res.data.mgmt_tasks);
          console.log(res.data.mgmt_tasks.date_list);
          let weekDay = res.data.mgmt_tasks.date_list;
          let getWeekDay = [];
          //初始work_date的个数为0；
          let intWorkList = [];
          for (let i = 0; i < weekDay.length; i++) {
            //console.log(weekDay[i][0]);
            intWorkList.push(0);
            let riqi = weekDay[i][0];
            let tian = weekDay[i][1];
            riqi = riqi.split("-");
            let Obj = {
              label: "",
              property: "work_date",
              tian: "",
              ri: "",
              qi: "",
              dayname: "",
            };
            let zhi = `${tian} | ${riqi[2]} | ${riqi[1]}月`;
            Obj.label = zhi;
            Obj.tian = tian;
            Obj.ri = riqi[2];
            Obj.qi = riqi[1];
            Obj.dayname = weekDay[i][0];
            getWeekDay.push(Obj);
          }
          console.log(getWeekDay);
          this.weekDay = getWeekDay;
          let gettableData = res.data.mgmt_tasks.mgmt_tasks;
          this.getprogress(gettableData);
          let tableArray = [];
          getBaseInfo().then((jieguo) => {
            this.base_info = jieguo;
            this.gettaskList(gettableData, jieguo);
          });
          console.log(this.tableData);
        });
    },
    //获取部门名字
    gettaskList(gettableData, base_info) {
      if (gettableData.length <= 0) {
      } else {
        let tableDataList = [];
        for (var i = 0; i < gettableData.length; i++) {
          let vms = gettableData[i];
          //获取部门名字

          //获取阶段名字
          for (let key in base_info.project_list) {
            if (vms.project_id == key) {
              vms["xiangmucn"] = base_info.project_list[key].project_name_cn;
            }
          }

          getpsheList(vms).then((res) => {
            //console.log(vms);
            vms["chioes"] = gettaskOptions(vms.depart_id, base_info, res);
            let chioseList = vms["chioes"];
            vms["value1"] = getTaskOptionValue(vms.task_id, chioseList);
            //console.log(vms);
            var taskoptions = base_info.depart_all_task_list[vms.depart_id];
            var scopeName = [];
            Object.assign(scopeName, vms["value1"]);
            if (scopeName.length > 0) {
              vms["task_name_str"] = gettasklistStrName(
                vms.task_id,
                scopeName,
                taskoptions
              );
            } else {
              vms["task_name_str"] = "";
            }
            tableDataList.push(vms);
            tableDataList.sort(function (a, b) {
              return a.depart_id - b.depart_id;
            });
            this.tableData = tableDataList;
            this.rowspan();
            this.$forceUpdate();
          });
        }
      }
    },
    getEmployee_depart() {
      return new Promise((resolve, reject) => {
        axios
          .post(IPConfig.IP + "/kpi-management/info/employee_departs.php", {})
          .then((res) => {
            //console.log(res.data.employee_departs);
            let employee_departs = res.data.employee_departs;
            for (let i in employee_departs) {
              employee_departs[i].employee_name_abbr =
                employee_departs[i]["employee_name"] +
                "-" +
                employee_departs[i]["depart_abbr"];
            }
            //console.log(employee_departs);
            this.employeeDeparts = employee_departs;
          });
      });
    },
    //项目改变查询
    handleChangeProject(el) {
      console.log(this.project_id);
      this.week_plan_id = "";
      this.getWeekPlan();
    },
    //周计划改变查询
    handleChangeWeek() {
      this.getPlanDetail();
    },
    cellClassName({ row, column, rowIndex, columnIndex }) {
      //console.log(row, column, rowIndex, columnIndex);
      row.index = rowIndex;
      //column.index = columnIndex;
      return "yangshi";
    },

    //修改单元格样式的方法 // 动态设置颜色
    addClass({ row, column, rowIndex, columnIndex }) {
      // console.log(column);
      // console.log(row);
      // console.log(rowIndex);
      // console.log(columnIndex);

    //   if (column.label === "状态") {
    //     if (row.task_status_explaination == "未完成") {
    //       return "background: red;padding: 4px 0";
    //     } else if (row.task_status_explaination == "已完成") {
    //       return "background: green;padding: 4px 0";
    //     } else if (row.task_status_explaination == "取消") {
    //       return "background: gray;padding: 4px 0";
    //     }
    //   }
      if (column.label === "部门") {
        if (row.depart_name == "市场") {
          return "background: #f59a23;color:#fff;padding: 4px 0";
        }
        if (row.depart_name == "造价") {
          return "background:#999933;color:#fff;padding: 4px 0";
        }
        if (row.depart_name == "项目") {
          return "background:#006699;color:#fff;padding: 4px 0";
        }
        if (row.depart_name == "创意") {
          return "background:#666699;color:#fff;padding: 4px 0";
        }
        if (row.depart_name == "施工设计") {
          return "background:#CC6633;color:#fff;padding: 4px 0";
        }
        if (row.depart_name == "媒体") {
          return "background:#009999;color:#fff;padding: 4px 0";
        }
        if (row.depart_name == "研发") {
          return "background: #02a7f0;color:#fff;padding: 4px 0";
        }
        if (row.depart_name == "采购") {
          return "background: #CC3399;color:#fff;padding: 4px 0";
        }
        if (row.depart_name == "系统集成") {
          return "background: #FF6666;color:#fff;padding: 4px 0";
        }
      }
      if (column.label == "日期") {
        let geziKey = row.work_date;
        let geziValue = column.index;
        //console.log(geziKey);
        //console.log(column.index);
        if (geziKey[geziValue] == 1) {
          return "background-color: red;padding: 4px 0";
        } else {
          return "background-color: #fff;padding: 4px 0";
        }
      } else {
        return "background:#fff;padding: 4px 0";
      }
    },
    rowspan() {
      this.spanArr = [];
      this.position = 0;
      this.tableData.forEach((item, index) => {
        if (index === 0) {
          this.spanArr.push(1);
          this.position = 0;
        } else {
          if (
            this.tableData[index].depart_id ===
            this.tableData[index - 1].depart_id
          ) {
            this.spanArr[this.position] += 1;
            this.spanArr.push(0);
          } else {
            this.spanArr.push(1);
            this.position = index;
          }
        }
      });
    },

    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      //表格合并行
      if (columnIndex === 0) {
        const _row = this.spanArr[rowIndex];
        const _col = _row > 0 ? 1 : 0;
        return {
          rowspan: _row,
          colspan: _col,
        };
      }
    },
  },
};
</script>

<style scoped>
.xuanR {
   color:red;
}
.xuanG {
   color:green;
}
.xuanY {
   color:gray;
}
.mybtn:focus {
  color: red;
}
.mybtn1:active {
  color: red;
}
.sortable-ghost {
  border: aqua 10px solid !important;
}
.handle,
.canDrag {
  cursor: move;
}

::v-deep .hover-row > td {
  background-color: #fff !important;
}

::v-deep .sortable-chosen > td {
  background-color: red !important;
}

::v-deep .el-table--enable-row-hover .el-table__body tr:hover > td {
  background-color: #fff;
}
.tianjia {
  height: 32px;
  width: 32px;
  line-height: 30px;
  padding-top: 0;
  padding-bottom: 0;
  cursor: pointer;
}
.lableName {
  width: 15%;
  line-height: 40px;
}
.xianshikuang {
  display: flex;
  padding: 10px;
}
.el-tag + .el-tag {
  margin-left: 10px;
}
.button-new-tag {
  margin-left: 10px;
  height: 32px;
  line-height: 30px;
  padding-top: 0;
  padding-bottom: 0;
}
.input-new-tag {
  width: 80px;
  margin-left: 10px;
  vertical-align: bottom;
}
[v-cloak] {
  display: none;
}

.hintsbox-mark {
  position: relative;
}

.hintsbox-mark input {
  width: 250px;
}

.hintsBox {
  position: absolute;
  z-index: 100000;
  /* top:264px;
  left:538px; */
  width: 120px;
  border: 1px solid #ddd;
  border-radius: 5%;
  background-color: skyblue;
  max-height: 200px;
  overflow-y: scroll;
}

/*滚动条样式*/
.hintsBox::-webkit-scrollbar {
  width: 1px;
  height: 4px;
}
.hintsBox::-webkit-scrollbar-thumb {
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  background: rgba(0, 0, 0, 0.2);
}
.hintsBox::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  border-radius: 0;
  background: rgba(0, 0, 0, 0.1);
}

.hintslist .hint {
  padding: 4px 4px;
}

.hintslist .hint:hover {
  background-color: #ddd8e5;
  cursor: pointer;
}

.hintslist .hint.active {
  background-color: #ddd8e5;
}
.selected {
  background-color: #ddd8e5 !important;
}
.selectKuang >>> .el-input__inner {
  border: 0;
}
/* 利用穿透，设置input边框隐藏 */
.inputDeep >>> .el-input__inner {
  border: 0;
}
/* 如果你的 el-input type 设置成textarea ，就要用这个了 */
.inputDeep >>> .el-textarea__inner {
  border: 0;
  min-height: 24px;
  resize: none; /* 这个是去掉 textarea 下面拉伸的那个标志，如下图 */
}
.mart3 {
  margin-top: 30px;
}
.xianshikuang {
  display: flex;
  align-items: center;
}
.lableName {
  width: 100px;
}
.yangshi {
  padding: 0 !important;
  text-align: center !important;
  color: #000;
  height: 40px !important;
}
.deftip {
  text-align: center;
  padding: 30px;
  color: red;
}
.withe {
  background: #fff;
}
.blue {
  background: #02a7f0;
}
.red {
  background: red;
}
.cell-grey {
  background: #f59a23;
}
.el-table th > .cell {
  padding: 0 !important;
  text-align: center;
}
.table >>> .cell {
  padding: 0 !important;
  text-align: center;
}
.daKuang {
  display: flex !important;
  flex-direction: column;
}
.waiKuang {
  height: 30px;
  font-size: 10px;
}
.riqi {
  font-size: 14px;
  padding: 10px 0;
}
.yuefen {
  font-size: 12px;
  font-weight: 500;
}
.jindukuang {
  width: 15%;
  height: 38px;
  font-weight: 500;
  border: 1px solid #dcdfe6;
  color: #606266;
  line-height: 38px;
  text-align: center;
}
.marginL2 {
  margin-left: 2%;
}
.addBtn {
  width: 100%;
  /* height: 30px; */
  font-size: 20px;
  cursor: pointer;
  position: absolute;
  bottom: 10px;
}
</style>


// WEBPACK FOOTER //
// src/views/Xinrenwu/zhanshi.vue